"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var customerOrderApi = _interopRequireWildcard(require("@/api/customerOrderApi.js"));
var _customerOrderPreApi = require("@/api/customerOrderPreApi");
var _debounce = _interopRequireDefault(require("@/libs/debounce.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { customerStateOptions } from '../static'
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      stateMap: [
      // 客户订单状态
      {
        value: 2,
        label: '已确认'
      }],
      loading: false,
      visible: false,
      pram: {},
      preBatchOptions: [],
      preBatchLoading: false,
      preBatchInfoLoading: false,
      selectedPreBatch: null,
      cardNoAssignList: []
    };
  },
  created: function created() {
    this.debouncedSubmit = (0, _debounce.default)(this.handerSubmit, 500);
  },
  methods: {
    initOpen: function initOpen() {
      var detailInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.pram = _objectSpread(_objectSpread({}, detailInfo), {}, {
        status: 2,
        makeCardType: 'pre',
        preBatchId: ''
      });
      this.preBatchOptions = [];
      this.preBatchInfoLoading = false;
      this.selectedPreBatch = null;
      this.cardNoAssignList = [];
      this.visible = true;
      this.getPreBatchOptions();
    },
    getPreBatchOptions: function getPreBatchOptions() {
      var _this = this;
      if (!this.pram.appId) {
        this.preBatchOptions = [];
        return;
      }
      this.preBatchLoading = true;
      (0, _customerOrderPreApi.customerOrderPreListApi)({
        status: 1,
        availableProgram: this.pram.appId
      }).then(function (res) {
        var list = _this.normalizePreBatchList(res);
        _this.preBatchOptions = list;
      }).finally(function () {
        _this.preBatchLoading = false;
      });
    },
    normalizePreBatchList: function normalizePreBatchList(res) {
      if (Array.isArray(res)) return res;
      if (res && Array.isArray(res.list)) return res.list;
      if (res && Array.isArray(res.records)) return res.records;
      if (res && res.page && Array.isArray(res.page.list)) return res.page.list;
      return [];
    },
    handleMakeCardTypeChange: function handleMakeCardTypeChange() {
      this.pram.preBatchId = '';
      this.selectedPreBatch = null;
      this.cardNoAssignList = [];
      this.preBatchInfoLoading = false;
      if (this.pram.makeCardType === 'pre') {
        this.getPreBatchOptions();
      }
    },
    handlePreBatchChange: function handlePreBatchChange(id) {
      this.selectedPreBatch = this.preBatchOptions.find(function (item) {
        return String(item.id) === String(id);
      }) || null;
      this.cardNoAssignList = this.selectedPreBatch ? [this.getDefaultAssignRow(this.selectedPreBatch)] : [];
      this.preBatchInfoLoading = false;
      if (this.selectedPreBatch) {
        this.getPreBatchAvailableInfo(this.selectedPreBatch.batchNo);
      }
    },
    getPreBatchAvailableInfo: function getPreBatchAvailableInfo(batchNo) {
      var _this2 = this;
      if (!batchNo) return;
      var currentBatchNo = batchNo;
      this.preBatchInfoLoading = true;
      (0, _customerOrderPreApi.customerOrderPreAvailableInfoApi)({
        batchNo: currentBatchNo
      }).then(function (res) {
        if (!_this2.selectedPreBatch || _this2.selectedPreBatch.batchNo !== currentBatchNo) return;
        var info = _this2.normalizePreBatchAvailableInfo(res);
        _this2.selectedPreBatch = _objectSpread(_objectSpread({}, _this2.selectedPreBatch), info);
        _this2.cardNoAssignList = [_this2.getDefaultAssignRow(_this2.selectedPreBatch)];
      }).finally(function () {
        if (_this2.selectedPreBatch && _this2.selectedPreBatch.batchNo === currentBatchNo) {
          _this2.preBatchInfoLoading = false;
        }
      });
    },
    normalizePreBatchAvailableInfo: function normalizePreBatchAvailableInfo(res) {
      if (res && res.data && _typeof(res.data) === 'object') return res.data;
      if (res && _typeof(res) === 'object') return res;
      return {};
    },
    getDefaultAssignRow: function getDefaultAssignRow(row) {
      var boundary = this.getRemainCardNoRangeBoundary(row);
      var quantity = Number(this.pram.quantity);
      if (!boundary) {
        return {
          cardNoStart: '',
          cardNoEnd: ''
        };
      }
      return {
        cardNoStart: String(boundary.start),
        cardNoEnd: Number.isInteger(quantity) && quantity > 0 ? String(Math.min(boundary.start + quantity - 1, boundary.end)) : String(boundary.start)
      };
    },
    getEmptyAssignRow: function getEmptyAssignRow() {
      return {
        cardNoStart: '',
        cardNoEnd: ''
      };
    },
    getRemainCardNoRangeBoundary: function getRemainCardNoRangeBoundary(row) {
      var rangeList = this.getRemainCardNoRangeList(row);
      if (!rangeList.length) return null;
      return {
        start: Math.min.apply(Math, _toConsumableArray(rangeList.map(function (item) {
          return item.start;
        }))),
        end: Math.max.apply(Math, _toConsumableArray(rangeList.map(function (item) {
          return item.end;
        })))
      };
    },
    addAssignRow: function addAssignRow() {
      if (!this.getRemainCardNoRangeBoundary(this.selectedPreBatch || {})) {
        this.$message.warning('没有可分配卡号段');
        return;
      }
      this.cardNoAssignList.push(this.getEmptyAssignRow());
    },
    removeAssignRow: function removeAssignRow(index) {
      this.cardNoAssignList.splice(index, 1);
    },
    getAvailableCount: function getAvailableCount(row) {
      if (row.canUseTotal !== undefined && row.canUseTotal !== null) return row.canUseTotal;
      if (!row.cardNoStart || !row.cardNoEnd) return 0;
      return Number(row.cardNoEnd) - Number(row.cardNoStart) + 1;
    },
    getRemainCardNoRange: function getRemainCardNoRange(row) {
      var rangeList = row.remainingCardNoRange;
      if (Array.isArray(rangeList)) {
        return rangeList.length ? rangeList.join('\n') : '--';
      }
      return rangeList || '--';
    },
    getRemainCardNoRangeList: function getRemainCardNoRangeList(row) {
      var rangeList = row.remainingCardNoRange;
      var source = Array.isArray(rangeList) ? rangeList : rangeList ? [rangeList] : [];
      return source.map(function (item) {
        var _String$split$map = String(item).split('-').map(function (value) {
            return Number(String(value).trim());
          }),
          _String$split$map2 = _slicedToArray(_String$split$map, 2),
          start = _String$split$map2[0],
          end = _String$split$map2[1];
        if (!Number.isInteger(start) || !Number.isInteger(end) || start <= 0 || end <= 0 || start > end) {
          return null;
        }
        return {
          start: start,
          end: end
        };
      }).filter(Boolean);
    },
    getAssignCount: function getAssignCount(row) {
      if (!this.isPositiveInteger(row.cardNoStart) || !this.isPositiveInteger(row.cardNoEnd)) return 0;
      var count = Number(row.cardNoEnd) - Number(row.cardNoStart) + 1;
      return count > 0 ? count : 0;
    },
    isPositiveInteger: function isPositiveInteger(value) {
      return /^[1-9]\d*$/.test(String(value).trim());
    },
    validateCardNoAssignList: function validateCardNoAssignList() {
      var _this3 = this;
      var availableBoundary = this.getRemainCardNoRangeBoundary(this.selectedPreBatch || {});
      var assignRanges = [];
      var totalCount = 0;
      if (!availableBoundary) {
        this.$message.error('当前没有可分配卡号段');
        return false;
      }
      var _loop = function _loop() {
          var item = _this3.cardNoAssignList[i];
          if (!_this3.isPositiveInteger(item.cardNoStart) || !_this3.isPositiveInteger(item.cardNoEnd)) {
            _this3.$message.error('卡号段开始和卡号段结束必须为大于0的正整数');
            return {
              v: false
            };
          }
          var start = Number(item.cardNoStart);
          var end = Number(item.cardNoEnd);
          if (start > end) {
            _this3.$message.error('卡号段开始必须小于等于卡号段结束');
            return {
              v: false
            };
          }
          if (start < availableBoundary.start || end > availableBoundary.end) {
            _this3.$message.error('卡号段不能超出当前可分配卡号段');
            return {
              v: false
            };
          }
          var isOverlap = assignRanges.some(function (range) {
            return start <= range.end && end >= range.start;
          });
          if (isOverlap) {
            _this3.$message.error('卡号段不能重复分配');
            return {
              v: false
            };
          }
          assignRanges.push({
            start: start,
            end: end
          });
          totalCount += end - start + 1;
        },
        _ret;
      for (var i = 0; i < this.cardNoAssignList.length; i++) {
        _ret = _loop();
        if (_ret) return _ret.v;
      }
      if (totalCount !== Number(this.pram.quantity)) {
        this.$message.error('分配数量和订单发放数量不相等');
        return false;
      }
      return true;
    },
    getSubmitData: function getSubmitData() {
      var _this4 = this;
      var isPreMakeCard = this.pram.makeCardType === 'pre';
      var batchNo = isPreMakeCard ? this.selectedPreBatch && this.selectedPreBatch.batchNo || '' : '';
      return {
        id: this.pram.id || '',
        status: 2,
        makeCardType: this.pram.makeCardType || '',
        preBatchId: isPreMakeCard ? this.pram.preBatchId || '' : '',
        preBatchNo: batchNo,
        batchNo: batchNo,
        cardNoAssignList: isPreMakeCard ? this.cardNoAssignList.map(function (item) {
          return {
            cardNoStart: item.cardNoStart || '',
            cardNoEnd: item.cardNoEnd || '',
            assignCount: _this4.getAssignCount(item)
          };
        }) : []
      };
    },
    handerSubmit: function handerSubmit(form) {
      var _this5 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        if (_this5.pram.makeCardType === 'pre' && !_this5.validateCardNoAssignList()) return;
        _this5.loading = true;
        var submitData = _this5.getSubmitData();
        customerOrderApi.changeStatePost(submitData).then(function (data) {
          _this5.$message.success('操作成功');
          _this5.loading = false;
          _this5.visible = false;
          _this5.$emit('doRefresh');
        }).catch(function () {
          _this5.loading = false;
        });
      });
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    }
  }
};